// removed by extract-text-webpack-plugin
module.exports = {"root":"ToolsArea__root___1QieB","header":"ToolsArea__header___1AYtC","title":"ToolsArea__title___22-HK"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateEditor/ToolsArea/ToolsArea.scss
// module id = 1040
// module chunks = 0